import { useState } from "react";
import { toast } from "sonner";
import { Download, UploadCloud } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Preview } from "@/pages/ImportPage";
import { api, download, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function BulkTransferDialog({ open, onOpenChange }) {
  const { bump } = useAuth();
  const [file, setFile] = useState(null);
  const [batch, setBatch] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const preview = async () => {
    if (!file) return toast.error("Select an Excel file");
    setBusy(true);
    setResult(null);
    try {
      const fd = new FormData();
      fd.append("kind", "dse-bulk");
      fd.append("file", file);
      const { data } = await api.post("/import/preview", fd);
      setBatch(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/import/confirm/${batch.id}`);
      setResult(data);
      bump();
      toast.success(`${data.created} transfer entries saved`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) { setBatch(null); setResult(null); setFile(null); } }}>
      <DialogContent className="max-w-5xl max-h-[92vh] overflow-y-auto" data-testid="dse-bulk-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">DSE Balance Transfer — Bulk Excel Upload</DialogTitle>
          <DialogDescription className="text-xs">
            Excel columns: <b>Date | DSE Name | Amount</b>. Amount = DSE ko diya total balance (DSE extra % included). System base = Amount ÷ (1 + rate) nikalega; outstanding sirf base se badhega.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap items-end gap-3">
          <Button variant="outline" onClick={() => download("/import/template/dse-bulk", {}, "ayzal_dse_bulk_transfer_template.xlsx").catch((e) => toast.error(errMsg(e)))} data-testid="dse-bulk-template-btn">
            <Download className="h-4 w-4" /> Sample template
          </Button>
          <Input type="file" accept=".xlsx,.csv" className="w-[260px]" onChange={(e) => { setFile(e.target.files?.[0] || null); setBatch(null); setResult(null); }} data-testid="dse-bulk-file-input" />
          <Button onClick={preview} disabled={busy} className="bg-[#D97706] hover:bg-[#b45309]" data-testid="dse-bulk-preview-btn"><UploadCloud className="h-4 w-4" /> Validate & preview</Button>
        </div>
        {batch && (
          <>
            <div className="text-sm text-slate-600" data-testid="dse-bulk-total-rows">Total rows: <b className="num">{batch.total_rows}</b></div>
            <Preview batch={batch} onConfirm={confirm} busy={busy} result={result} />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
